import type { Map as MapTypes } from 'mapbox-gl';
import React, { useEffect, useState } from 'react';

import { pushMapOpened } from 'src/components/Mapbox/analitics';
import { tilesUrlv2 } from 'src/utils/mapUtils';

import Map from 'src/components/Mapbox';
import { ActiveHotel } from './components/ActiveHotel';
import { useHotelsLayer, usePopup, useRegionsLayer } from './hooks';
import { getZoomProps } from './utils';

import type { MapboxSearchProps } from './types';

/**
 * Карта для страницы поиска
 * выводим список отелей, при клике повялется карточка отеля
 */
export const MapboxSearch = (props: MapboxSearchProps) => {
  const {
    hotelsList,
    regionsList,
    activeHotel,
    mapPosition,
    setPopupDataHandler,
    children,
    className,
    isMobile = false,
    isHotelCardOpened,
    isHeaderBannerHidden,
    getImages,
  } = props;

  const [mapbox, setMapbox] = useState<MapTypes>();
  useHotelsLayer({ mapbox, hotelsList });
  useRegionsLayer({ mapbox, regionsList });
  usePopup({
    mapbox,
    isMobile,
    setPopupDataHandler,
    getImages,
  });

  /**
   * Нужно изменить размер карты, если произошло скрытие/раскрытие баннера-перетяжки
   */
  useEffect(() => {
    mapbox?.resize();
  }, [mapbox, isHeaderBannerHidden]);

  const zoomProps = getZoomProps(mapPosition, mapbox);

  const handleFirstClick = () => {
    if (isMobile) return;

    pushMapOpened();
  };

  return (
    <Map
      onClick={handleFirstClick}
      tilesUrl={tilesUrlv2}
      className={className}
      isMobile={isMobile}
      onStyleLoad={setMapbox}
      {...mapPosition}
      {...zoomProps}
    >
      {children}

      {activeHotel && hotelsList.length && (
        <ActiveHotel
          coordinates={activeHotel.coordinates}
          isHotelCardOpened={isHotelCardOpened}
        />
      )}
    </Map>
  );
};
